import React, { useState, useContext, useEffect, useMemo } from 'react';
import { Accordion, Button, Form } from 'react-bootstrap';
import { loadJson } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { JSONContext } from '../Store';
import configAdmin from './admin/configAdmin.json';
import { getFilterVariables, getSegregationVariables, getSegregationSelections, executeSegregation, getPageContent } from './admin/apiCalls';
import { store, StateProvider } from '../Store';

const { SEGREGATIONPAGE_CODE } = configAdmin;

export default function SegregationModuleForm() {

  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;

  const {
    setResponseJSON,
    setTextSPC,
    setFormTypeQuery,
    formData,
    setFormData,
    setIsLoading,
    setFirstResponseJSON
  } = useContext(JSONContext);

  const [filterVariables, setFilterVariables] = useState([]); 
  const [segregationVariables, setSegregationVariables] = useState([]); 
  const [segregationSelections, setSegregationSelections] = useState([]); 
  const [validated, setValidated] = useState(false);
  const [filterCheckboxes, setFilterCheckboxes] = useState({});
  const [hideSelectDAME, setHideSelectDAME] = useState(true);
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  const [textContent, setTextContent] = useState({});

  const navigate = useNavigate();
  const defaultDA = (configData?.enabledDA && configData.enabledDA.length > 0) ? configData.enabledDA[0] : 'DAM';
  const defaultCensus = configData?.dbAlias?.find((item) => item.enabledSegregation)?.name || configData?.dbAlias?.[0]?.name || '';

  // reset form values when page loads
  useEffect(() => {
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
    getFilterVariables().then(setFilterVariables);
    getSegregationVariables().then(setSegregationVariables);
    getSegregationSelections().then(setSegregationSelections);
    getPageContent(setTextContent, SEGREGATIONPAGE_CODE);
  }, []);

  useEffect(() => {
    if (!configData) {
      return;
    }

    setFormData((prevFormData) => {
      const previous = prevFormData || {};

      return {
        ...previous,
        selectedDA: previous.selectedDA || defaultDA,
        selectedCensus: previous.selectedCensus || defaultCensus,
        selectedPopulationWeight: previous.selectedPopulationWeight || ''
      };
    });
  }, [configData, setFormData, defaultDA, defaultCensus]);

  useEffect(() => {
    if (formData?.selectedDA && formData.selectedDA !== 'DAM') {
      setHideSelectDAME(false);
    } else {
      setHideSelectDAME(true);
    }
  }, [formData]);

  useEffect(() => {
    if (segregationSelections.length > 0) {
      setFormData((prev) => ({
        ...prev,
        selectedSegregationSelection: -1
      }));
    }
  }, [segregationSelections, setFormData]);

  const styleTheme = {
    'button': `${configData?.theme && configData.theme}-button`,
    'title': `${configData?.theme && configData.theme}-title`,
    'checkButton': `${configData?.theme && configData.theme}-form-check-input`,
    'formGroup': `${configData?.theme && configData.theme}-odisea-form-group`,
  }

  const populationWeightsConfig = textContent?.additionalData?.populationWeights;

  const populationWeightOptions = useMemo(() => {
    if (!populationWeightsConfig?.enabled) {
      return [];
    }

    const rawItems = populationWeightsConfig.items;
    const itemsArray = Array.isArray(rawItems)
      ? rawItems
      : (rawItems && typeof rawItems === 'object'
        ? Object.values(rawItems)
        : []);

    return itemsArray
      .filter((item) => item && item.label && item.label.trim() !== '')
      .map((item, itemIndex) => ({
        id: `population-weight-${itemIndex}`,
        value: item?.value !== undefined && item?.value !== null ? `${item.value}` : '',
        label: item.label
      }));
  }, [populationWeightsConfig]);

  const populationWeightFormSet = populationWeightOptions.length ? {
    label: 'Ponderador de Población',
    name: 'population-weight',
    items: populationWeightOptions
  } : null;

  useEffect(() => {
    if (populationWeightOptions.length === 0) {
      setFormData((prev) => {
        if (!prev?.selectedPopulationWeight) {
          return prev;
        }
        return {
          ...prev,
          selectedPopulationWeight: ''
        };
      });
      return;
    }

    setFormData((prev) => {
      if (!prev) {
        return prev;
      }

      const hasSelection = populationWeightOptions.some((option) => option.value === prev.selectedPopulationWeight);
      if (hasSelection) {
        return prev;
      }

      return {
        ...prev,
        selectedPopulationWeight: populationWeightOptions[0].value
      };
    });
  }, [populationWeightOptions, setFormData]);

  const applyFilters = (spcText) => {
    let newSpcText = spcText;
    if (formData?.selectedFilterClasses && formData.selectedFilterClasses.length > 0) {
      let fullNewFilterList = []
      formData.selectedFilterClasses.map((item) => {
        fullNewFilterList.push(`${filterVariables[formData.selectedFilterFeature]['variableName']} = ${item}`);
      });

      newSpcText = spcText.replace(/SELECTION ALL/gi, `filter ${fullNewFilterList.join(' OR ')}`)
    }

    return (newSpcText);
  };

  const parseFilters = (spcText) => {
    let result = '';
    if (formData?.selectedFilterClasses && formData.selectedFilterClasses.length > 0) {
      let fullNewFilterList = []
      formData.selectedFilterClasses.map((item) => {
        fullNewFilterList.push(`${filterVariables[formData.selectedFilterFeature]['variableName']} = ${item}`);
      });

      result = `filter ${fullNewFilterList.join(' OR ')}`
    }

    return (result);
  };

  /*
  const submitForm = () => {

    if (
      !formData?.selectedSegregationFeature ||
      (formData?.selectedSegregationFeature && formData.selectedSegregationFeature === '')
    ) {
      alert('Debe completar todos los campos obligatorios del formulario');
      return -1;
    }

    setFormData({
      ...formData,
      selectedResultType: ['indicators']
    })

    setFormTypeQuery('segregation');
    let titleLabel = '';
    let newSpc = 'RUNDEF JOB\nSELECTION ALL\n';
    newSpc = applyFilters(newSpc);

    let segregationSelections = ''
    if ((formData?.selectedDA && formData.selectedDA !== 'DAM') &&
      (formData?.selectedSegregationSelection && formData?.selectedSegregationSelection !== -1)
    ) {
      segregationSelections = `selection \\"${formData.selectedSegregationSelection.replace('\\', '\\\\')}\\"`;
      newSpc = newSpc.replaceAll('SELECTION ALL', '');
    }

    titleLabel = `${segregationVariables[formData.selectedSegregationFeature]['label']} | ${formData.selectedDA}`;

    newSpc = newSpc + '\n' + buildQuery(
      'segregation', // queryType,
      'index', //resultType,
      formData.selectedDA, //daType,
      `index0`, //tableName
      titleLabel,
      `0`, //indexNumber,
      '', // filterText,
      `index-0`, // outputNameJSON
      segregationVariables[formData.selectedSegregationFeature]['name'],
      segregationSelections
    )

    setTextSPC(newSpc);
    setIsLoading(true);

    execSPC(DATABASE_ALIAS, newSpc, (resp) => {
      //setResponseJSON(resp);
      //console.log(resp);
      let result = {};
      try {
        result = JSON.parse(resp);
      } catch {
        //result = {type: 'Exception', message: 'Error en respuesta desde el servidor'};
        result = {type: 'Exception', message: 'Error en respuesta desde el servidor \n\n' + resp};
      }

      if (result?.type && result.type === 'Exception') {
        result?.message && alert('ERROR EN EL SERVIDOR: ' + result.message);
        navigate(-1);
      }

      setFirstResponseJSON(result); // first response

      // set responses to empty
      setResponseJSON([]);

      // call the API for each result
      const requests = result.outputs.map(async (outputItem) => {
        let responses = {
          path: '',
          data: ''
        }

        await loadJson(result.id, outputItem.file, (jsonResult) => {
          responses.path = `${result.id}/${outputItem.file}`;
          responses.data = jsonResult;
        });
        
        return responses;
      })
      
      // when API finishes loading, set statuses
      Promise.all(requests).then((requests) => {
        setResponseJSON(requests);
        setIsLoading(false);
      });
    });

    navigate('/visualizations');
  }

  */

  const submitForm = () => {

    if (
      !formData?.selectedSegregationFeature ||
      (formData?.selectedSegregationFeature && formData.selectedSegregationFeature === '')
    ) {
      alert('Debe completar todos los campos obligatorios del formulario');
      return -1;
    }

    setFormData({
      ...formData,
      selectedResultType: ['indicators']
    })

    setFormTypeQuery('segregation');

    let titleLabel = '';    

    let segregationSelections = ''
    if ((formData?.selectedDA && formData.selectedDA !== 'DAM') &&
      (formData?.selectedSegregationSelection && formData?.selectedSegregationSelection !== -1)
    ) {
      segregationSelections = `selection "${formData.selectedSegregationSelection}"`;
    }

    titleLabel = `${segregationVariables[formData.selectedSegregationFeature]['label']} | ${formData.selectedDA}`;
    
    setIsLoading(true);
    
    executeSegregation({
      filters: parseFilters(),
      title: titleLabel,
      daType: formData.selectedDA,
      segregationVariable: segregationVariables[formData.selectedSegregationFeature]['name'],
      selection: segregationSelections,
      databaseAlias: formData.selectedCensus,
      selectedPopulationWeight: formData.selectedPopulationWeight,
    }, (resp) => {
      //setResponseJSON(resp);
      //console.log(resp);
      let result = {};
      try {
        result = JSON.parse(resp);
      } catch {
        //result = {type: 'Exception', message: 'Error en respuesta desde el servidor'};
        result = {type: 'Exception', message: 'Error en respuesta desde el servidor \n\n' + resp};
      }
      
      // if (result?.response && result?.response?.type && result.response.type === 'Exception') {
      //   result?.message && alert('ERROR EN EL SERVIDOR: ' + result.message);
      //   navigate(-1);
      // }
      
      result?.query && setTextSPC(result.query);
      result?.response && setFirstResponseJSON(result.response); // first response
      
      // set responses to empty
      setResponseJSON([]);
      
      // call the API for each result
      const requests = result.response.outputs.map(async (outputItem) => {
        let responses = {
          path: '',
          data: ''
        }
        
        await loadJson(result.response.redsessionid, outputItem.file, (jsonResult) => {
          responses.path = `${result.response.redsessionid}/${outputItem.file}`;
          responses.data = jsonResult;
        });
        
        return responses;
      })
      
      // when API finishes loading, set statuses
      Promise.all(requests).then((requests) => {
        setResponseJSON(requests);
        setIsLoading(false);
      });
    });
    
    navigate('/visualizations');
  }
  

  let censusFormSet = {
    label: 'Base de datos:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "edit-census",
    items: []
  };
  configData?.dbAlias && configData.dbAlias.map((item) => {
    item.enabledSegregation && censusFormSet.items.push(
      {id: "edit-census-" + 1, value: item.name, label: item.label}
    )
  });


  let DATypeFormSet = {
    label: 'División Administrativa:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "damedam",
    items: []
  };
  configData?.enabledDA && configData.enabledDA.map((item) => {
    DATypeFormSet.items.push(
      {id: "edit-damedam-" + item, value: item, label: "Distrito - " + item}
      )
    });

  // validate submit form
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const submitText = 'Ejecutar';
  const emptySelectText = '- Seleccionar -';

  const DALabels = {
    'DAM': configData?.DALabels ? `${configData.DALabels["DAM"]} (DAM)` : 'Departamento (DAM)',
    'DAMI': configData?.DALabels ? `${configData.DALabels["DAMI"]} (DAMI)` : 'Provincia (DAMI)',
    'DAME': configData?.DALabels ? `${configData.DALabels["DAME"]} (DAME)` : 'Distrito (DAME)',
  };

  return (
    <>
    <p>{/* JSON.stringify( formData ) */}</p>
    <h3>Seleccione Parámetros </h3>
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
    <div className="odisea-parent">
      <div className="odisea-child1">
      <Accordion defaultActiveKey={['0']} alwaysOpen>
        <Accordion.Item className="odisea-form-accordion-item" eventKey="0">
          <Accordion.Header className={ "odisea-form-accordion-header " + styleTheme.title}>Datos obligatorios*</Accordion.Header>
          <Accordion.Body>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ censusFormSet.label }</Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              value={formData?.selectedCensus || defaultCensus}
              onChange={ (e) => {
                  setFormData((prev) => ({
                    ...prev,
                    selectedCensus: e.target.value
                  }));
              } }
            >
              { censusFormSet.items.map((item, itemId) => <option key={ item.id } value={ item.value }>{ item.label }</option>) }
            </Form.Select>
          </Form.Group>
          <Form.Group className={"odisea-form-group test "  + styleTheme.formGroup}>
          <Form.Label className={ 'odisea-form-label' } htmlFor="edit-filters">{ DATypeFormSet.label }</Form.Label>
            <Form.Select
                id="edit-alias"
                name="alias"
                value={formData?.selectedDA || defaultDA}
                onChange={ (e) => {
                    setFormData((prev) => ({
                      ...prev,
                      selectedDA: e.target.value
                    }));
                } }
              >
              { DATypeFormSet.items.map((item, itemId) => <option key={ item.id } value={ item.value }>{ DALabels[item.value] }</option>) }
            </Form.Select>

            <br hidden = { hideSelectDAME } />
            <Form.Label hidden = { hideSelectDAME } className="odisea-form-label" htmlFor="edit-alias">{ "Selección geográfica" }</Form.Label>

            <Form.Select
              id="edit-alias"
              name="alias"
              className="form-select"
              hidden = { hideSelectDAME }
              defaultValue = {segregationSelections.length > 0 && segregationSelections[0].name}
              onChange={ (e) => {
                setFormData({
                  ...formData,
                  selectedSegregationSelection: e.target.value
                })
              } }
            >
              <option key={ -1 } value={ -1 }>{ 'Todo' }</option>
              { segregationSelections.map((item, itemId) => <option key={ itemId } value={ item.name }>{ item.label }</option>) }
            </Form.Select>

          </Form.Group>
          { populationWeightFormSet && (
            <Form.Group className={"odisea-form-group test "  + styleTheme.formGroup}>
              <Form.Label className="odisea-form-label" htmlFor="edit-population-weight">{ populationWeightFormSet.label }</Form.Label>
              <Form.Select
                id="edit-population-weight"
                name={ populationWeightFormSet.name }
                value={ formData?.selectedPopulationWeight || '' }
                onChange={ (e) => {
                  setFormData({
                    ...formData,
                    selectedPopulationWeight: e.target.value
                  });
                } }
              >
                { populationWeightFormSet.items.map((item) => <option key={ item.id } value={ item.value }>{ item.label }</option>) }
              </Form.Select>
            </Form.Group>
          )}
          <Form.Group className={"odisea-form-group test "  + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-alias">{ 'Variable segregadora' }</Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              className="form-select"
              required
              onChange={ (e) => {
                setFormData({
                  ...formData,
                  selectedSegregationFeature: e.target.value,
                  selectedSegregationClasses: []
                })
              } }
            >
              <option value="" defaultValue="selected">{ emptySelectText }</option>
              { segregationVariables.map((item, itemId) => <option key={ item.id } value={ itemId }>{ item.label }</option>) }
            </Form.Select>
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
    </div>
    <div className="odisea-child2">
    <Accordion defaultActiveKey={['0']} alwaysOpen>
      <Accordion.Item className="odisea-form-accordion-item" eventKey="1">
        <Accordion.Header className={ "odisea-form-accordion-header " + styleTheme.title }>Filtros opcionales</Accordion.Header>
        <Accordion.Body>
          <Form.Group className={"odisea-form-group test "  + styleTheme.formGroup}>
          <Form.Label className="odisea-form-label" htmlFor="edit-filters">Filtrar por: </Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              className="form-select"
              onChange={ (e) => {
                setFormData({
                  ...formData,
                  selectedFilterFeature: e.target.value,
                  selectedFilterClasses: []
                })
                
                setFilterCheckboxes(filterVariables[e.target.value]);
              } }
            >
              <option value="" defaultValue="selected">{ emptySelectText }</option>
              { filterVariables.map((item, itemId) => <option key={ item.id } value={ itemId }>{ item.selectLabel }</option>) }
            </Form.Select>
          </Form.Group>
          <Form.Group className={"odisea-form-group test "  + styleTheme.formGroup}>
            {/*<Form.Label className="odisea-form-label" htmlFor="edit-filters">{ filterCheckboxes.label }</Form.Label>*/}
            { filterCheckboxes?.checkItems && filterCheckboxes.checkItems.map((item, itemId) => 
              <Form.Check 
                className={ styleTheme.checkButton }
                type={ filterCheckboxes.controlType }
                key={ itemId }
                label={ item.label }
                name={ filterCheckboxes.name }
                value={ item.variableValue }
                onChange={ (e) => {
                  let selectedFilterClasses = []
                  if (formData.hasOwnProperty('selectedFilterClasses')) {
                    selectedFilterClasses = formData.selectedFilterClasses;
                  }
                  if (e.target.checked){
                    setFormData({
                      ...formData,
                      selectedFilterClasses: [...selectedFilterClasses, e.target.value]
                    });
                  } else {
                    setFormData({
                      ...formData,
                      selectedFilterClasses: selectedFilterClasses.filter(item => item !== e.target.value)
                    });
                  }
                } }
              />
            )}  
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    <Form.Group className="odisea-form-group odisea-form-group-button">
      <Button type="submit" className={ "odisea-form-button-submit " + styleTheme.button } onClick={() => {submitForm()}}>{submitText}</Button>
    </Form.Group>
    </div>
  </div>
  </Form>
  </>
  )
}
